import React from 'react'
import AxisLabel from './axis-label'
import EasingTick from './shapes/easing-tick'
import { labelDimensions } from './layouts/gutters'
import colors from './colors'
import { extent } from 'd3-array'

import { CHART_DEBUG, PADDING } from './constants'

class YAxis extends React.PureComponent {
  static defaultProps = {
    className: '',
    format: n => n,
    inverted: false,
    label: '',
    offset: 0,
    ticks: [],
    width: 0,
    tickColor: colors.label,
    labelColor: colors.label,
    x: 0,
    y: 0,
    ruled: false
  }

  getHeight() {
    const [bottom, top] = this.props.scale.range()

    return Math.abs(bottom - top)
  }

  renderTick(tick, index) {
    const { scale, format, width, offset, inverted, tickColor } = this.props

    const x = inverted ? PADDING : width - PADDING
    const align = inverted ? 'start' : 'end'

    return (
      <EasingTick
        key={index}
        x={x}
        y={scale(tick) + offset}
        label={format(tick)}
        align={align}
        baseline="middle"
        fill={tickColor}
      />
    )
  }

  renderDebug(label) {
    const { scale, width, inverted } = this.props
    const [_bottom, top] = scale.range()
    const height = this.getHeight()

    const x = inverted ? 0 : width - PADDING

    return (
      <g fill="none" strokeDasharray="2 1">
        {/* padding-outer */}
        <rect x={x} y={top} height={height} width={PADDING} stroke="orange" />
      </g>
    )
  }

  renderRule() {
    const { scale, ticks } = this.props

    const range = ticks.map(scale)
    const [top, bottom] = extent(range)

    return <line y1={bottom} y2={top} stroke={colors.label} strokeWidth="1" />
  }

  renderLabel(label) {
    const { scale, inverted, width, labelColor } = this.props
    const [bottom, top] = scale.range()
    const height = this.getHeight()

    const y = inverted ? top : bottom
    const x = inverted ? width : 0
    const rotate = inverted ? 90 : -90

    return (
      <AxisLabel
        className="chart-show-large"
        x={x}
        y={y}
        label={label}
        width={height}
        rotate={rotate}
        fill={labelColor}
      />
    )
  }

  render() {
    const { className, ticks, label, x, y, ruled } = this.props

    const lines = labelDimensions(label.toUpperCase(), this.getHeight())

    return (
      <g className={`axis -y ${className}`} transform={`translate(${x},${y})`}>
        {CHART_DEBUG ? this.renderDebug(lines) : null}

        {ruled ? this.renderRule() : null}

        {ticks.map(this.renderTick, this)}

        {this.renderLabel(lines)}
      </g>
    )
  }
}

export default YAxis



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/y-axis.js